import {Box, FormHelperText, TextField, Typography} from "@mui/material";
import * as Yup from "yup";
import React from "react";
import CustomButtonColor from "../../../components/custom-button/customColorButton";
import Payment from 'payment'
import {useFormik} from "formik";
import SubmitButton from "../../../components/custom-button/submitButton";
import {useDispatch} from "react-redux";
import { CreditCard, PaymentForm} from 'react-square-web-payments-sdk';
import {storeUserCreateCard} from "../../../store/user/user-cards";
import CloseIcon from '@mui/icons-material/Close';
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
  successConfirmation
} from "../../../services/utills";
import toast from "react-hot-toast";


const styles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '450px',
  bgcolor: '#FAF6F2',
  borderRadius: '20px',
  overflow: 'hidden',
  boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
  '@media (max-width:500px)': { width: '92%' },
  '@media (max-width:319px)': { width: '95%' },
};

const AddUserCard = ({user,active,setLoading,setIsOpen,type,setAddPayment,handlePayment,cardStores}) => {
  // const [active, setActive] = useState(false)


  const dispatch = useDispatch()

  const validationSchema = Yup.object({
    number: Yup.string().required('Card number is required'),
    expirationDate: Yup.string().required('Expiry date is required'),
    cvv: Yup.string().required('CVC is required'),
  });

  const {
    values,
    handleSubmit,
    setFieldTouched,
    setFieldError,
    setFieldValue,
    resetForm,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      number: '',
      expirationDate: '',
      cvv: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (data, {}) => {

      setLoading(true);
      let res = await dispatch(storeUserCreateCard({...data, provider_id: user?.defaultProvider?.id}));

      if (res?.payload.success === 'true') {
        if(type === 'membership'){
         await handlePayment(res?.payload?.data)
        }else {
          toast.success(`Card added successfully`, {duration: 3000})
          // toast.success('Card Added Successfully')
        }
        handleClose()
        resetForm()
      }
      if (res?.payload?.errors) {
        let errors = res?.payload?.errors;

        if (errors?.number) {
          await setFieldTouched('number', true);
          setFieldError('number', "Invalid Card Number");
        }
        if (errors?.expirationDate) {
          await setFieldTouched('expirationDate', true);
          setFieldError('expirationDate', "Invalid expiry date");
        }
        if (errors?.cvv) {
          await setFieldTouched('cvv', true);
          setFieldError('cvv', "Invalid CVC");
        }
      }
      setLoading(false)
    },
  });

  const handleClose = () => {
    if (setIsOpen){
      setIsOpen(false);
    }
  };


  const handleInputChange = ({target}) => {
    const {name, value} = target
    if (name === 'number') {
      let res = formatCreditCardNumber(value, Payment)
      setFieldValue('number', res)
      // handleChange({target:{name:'number',value:res}})
    } else if (name === 'expirationDate') {
      let res = formatExpirationDate(value)
      setFieldValue('expirationDate', res)
    } else if (name === 'cvv') {
      let res = formatCVC(value, values?.number, Payment)
      setFieldValue('cvv', res)

    }
  }

  return (

      <Box sx={styles}>
        {/* Header */}
        <Box sx={{
          background: 'linear-gradient(135deg, #C0357A 0%, #9B2860 100%)',
          px: 3, py: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <Typography sx={{ fontSize: '17px', fontWeight: 700, color: '#fff' }}>
            Setup Your Payment
          </Typography>
          <Box onClick={handleClose} sx={{
            width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
            '&:hover': { background: 'rgba(255,255,255,0.35)' },
          }}>
            <CloseIcon sx={{ fontSize: 16, color: '#fff' }} />
          </Box>
        </Box>

        {/* Body */}
        <Box sx={{ p: 3 }}>
        <Typography sx={{ fontSize: '14px', color: '#78716C', mb: 2.5 }}>
          Your membership starts as soon as you set up payment.
        </Typography>

        {active?.payment_gateway === 'Square' ?
            <Box>
              <PaymentForm
                  applicationId={active?.application_key}
                  locationId={active?.merchant_id}
                  cardTokenizeResponseReceived={async (token,) => {
                    let res = await dispatch(storeUserCreateCard({
                      "provider_id": active?.provider_id,
                      "nonce": token?.token
                    }));
                    if (res?.payload?.success === 'true') {

                      if(type === 'membership'){
                        await handlePayment(res?.payload?.data)
                      }else {

                        toast.success(`Card added successfully`, {duration: 3000})
                        handleClose()
                      //  toast.success('Card Added Successfully')

                      }
                    }
                  }}
              >
                <CreditCard
                    buttonProps={{
                      css: {
                        marginTop: '15px',
                        fontSize: "14px",
                        fontWeight: 700,
                        backgroundColor: "#C0357A",
                        border: '1px solid #C0357A',
                        color: "#fff",
                        borderRadius: '12px',
                        "&:hover": {
                          backgroundColor: "#9B2860",
                          border: '1px solid #9B2860',
                        },
                        '@media (max-width:500px)': { width: '100%' },
                      }
                    }}
                >
                  Continue
                </CreditCard>
              </PaymentForm>
            </Box>
            :
            <form onSubmit={handleSubmit}>
              <Box>
                <TextField
                    value={values.number}
                    onChange={handleInputChange}
                    label="Card Number"
                    name="number"
                    variant="outlined"
                    placeholder='0000 0000 0000 0000'
                    sx={{ width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '12px', background: '#fff', '& fieldset': { borderColor: '#F0E6DF' }, '&:hover fieldset': { borderColor: '#C0357A' }, '&.Mui-focused fieldset': { borderColor: '#C0357A' } }, '& label.Mui-focused': { color: '#C0357A' } }}
                />
                {errors.number && touched.number && <FormHelperText
                    sx={{color: '#CB3838', width: 'max-content', mx: 0}}>{errors.number}</FormHelperText>}
              </Box>
              <Box style={{display: "flex", justifyContent: "space-between", marginTop: '30px'}}>
                <Box>
                  <TextField
                      value={values?.expirationDate}
                      onChange={handleInputChange}
                      name="expirationDate"
                      variant="outlined"
                      placeholder='MM/YY'
                      inputProps={{maxLength: '5'}}
                      label="Expiry Date"
                      sx={{marginRight: "10px"}}
                  />
                  {errors.expirationDate && touched.expirationDate &&
                      <FormHelperText sx={{color: '#CB3838', width: 'max-content', mx: 0}}>
                        {errors.expirationDate}
                      </FormHelperText>
                  }
                </Box>
                <Box>
                  <TextField
                      value={values?.cvv}
                      onChange={handleInputChange}
                      name="cvv"
                      variant="outlined"
                      label="CVC"
                      sx={{marginRight: "10px"}}
                  />
                  {errors.cvv && touched.cvv &&
                      <FormHelperText sx={{color: '#CB3838', width: 'max-content', mx: 0}}>
                        {errors.cvv}
                      </FormHelperText>
                  }
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: '10px', mt: 3 }}>
                <Box
                    component="button"
                    type="button"
                    onClick={handleClose}
                    sx={{
                      flex: 1, height: '48px', borderRadius: '12px',
                      border: '1.5px solid #EB5757', background: '#EB5757',
                      color: '#fff', fontSize: '14px', fontWeight: 600,
                      cursor: 'pointer', '&:hover': { borderColor: '#EB5757', color: '#EB5757', background: '#fff' },
                    }}
                >
                  Cancel
                </Box>
                <Box
                    component="button"
                    type="submit"
                    sx={{
                      flex: 1, height: '48px', borderRadius: '12px',
                      border: '1.5px solid #27AE60', background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
                      color: '#fff', fontSize: '14px', fontWeight: 700,
                      cursor: 'pointer', '&:hover': { background: '#219653', color: '#fff', border: '1.5px solid #27AE60' },
                    }}
                >
                  Continue
                </Box>
              </Box>
            </form>
        }
       {type === "membership" && cardStores?.length > 0 ? (
          <Typography onClick={() => setAddPayment(true)} sx={{ cursor: "pointer", color: "#C0357A", textAlign: 'center', mt: 2, fontSize: '14px', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}>
            Use Existing Cards
          </Typography>
        ) : null}
        </Box>{/* end body */}
      </Box>
  );
};

export default AddUserCard;
